// Generated by genversion.
export const version = '1.30.0';
